import { render, staticRenderFns } from "./PassportIssuerSearch.vue?vue&type=template&id=040692e4"
import script from "./PassportIssuerSearch.vue?vue&type=script&lang=js"
export * from "./PassportIssuerSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports